import React from 'react';
import { MapPin, TrainFront, Car, Lock, Phone, Mail } from 'lucide-react';

const ITEMS = [
  { icon: MapPin, title: 'Neighborhood', text: 'East Williamsburg, Brooklyn, NY' },
  { icon: TrainFront, title: 'Nearest subway', text: 'Montrose Av (L train) - a short walk to the studio.' },
  { icon: Car, title: 'Getting here', text: 'Easy to reach by the L, rideshare or car. Street parking is available nearby - check posted signs.' },
  { icon: Lock, title: 'Exact address', text: 'Sent privately in your booking confirmation for everyone\'s safety.' },
];

export const LocationInfo = () => (
  <section id="location" data-testid="location-section" className="py-16 bg-black">
    <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
      <p className="text-xs uppercase tracking-[0.25em] text-purple-400 mb-3">Location</p>
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">Studio in East Williamsburg, Brooklyn</h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map(({ icon: Icon, title, text }) => (
          <div key={title} data-testid={`location-${title.toLowerCase().replace(/\s/g, '-')}`} className="rounded-xl border border-purple-500/20 bg-purple-950/20 p-5">
            <Icon size={20} className="text-purple-400 mb-3" />
            <h3 className="text-white font-semibold text-sm mb-1">{title}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 flex flex-wrap gap-4 text-sm">
        <a data-testid="location-call-link" href="tel:+19294131993" className="inline-flex items-center gap-2 text-gray-300 hover:text-white transition-colors">
          <Phone size={15} className="text-purple-400" /> (929) 413-1993
        </a>
        <a data-testid="location-email-link" href="mailto:info@hqstu.com" className="inline-flex items-center gap-2 text-gray-300 hover:text-white transition-colors">
          <Mail size={15} className="text-purple-400" /> info@hqstu.com
        </a>
      </div>
    </div>
  </section>
);

export default LocationInfo;
